import React, { createContext, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Routes, useLocation } from 'react-router-dom';
import './PageTransition.css';

export const PageTransitionContext = createContext('idle');

export default function PageTransition({ children }) {
  const location = useLocation();
  const [displayedLocation, setDisplayedLocation] = useState(location);
  const displayed = useRef(location);
  const [phase, setPhase] = useState('idle');

  useLayoutEffect(() => {
    // Translation switches and anchors should remain immediate.
    if (location.pathname === displayed.current.pathname ||
        window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      displayed.current = location;
      setDisplayedLocation(location);
      setPhase('idle');
      return;
    }

    setPhase('out');
    let enterTimer;
    let holdTimer;
    const exitTimer = window.setTimeout(() => {
      displayed.current = location;
      setDisplayedLocation(location);
      setPhase('hold');
      holdTimer = window.setTimeout(() => {
        setPhase('in');
        enterTimer = window.setTimeout(() => setPhase('idle'), 650);
      }, 300);
    }, 2100);
    return () => {
      window.clearTimeout(exitTimer);
      window.clearTimeout(enterTimer);
      window.clearTimeout(holdTimer);
    };
  }, [location]);

  return (
    <div className={`page-transition page-transition--${phase}`} inert={phase === 'out' || phase === 'hold' ? '' : undefined}>
      <PageTransitionContext.Provider value={phase}>
        <Routes location={displayedLocation}>{children}</Routes>
      </PageTransitionContext.Provider>
      {phase !== 'idle' && createPortal(
        <div className={`page-transition-curtain page-transition-curtain--${phase}`} aria-hidden="true" />,
        document.body
      )}
    </div>
  );
}
